<template>
  <div class="q-px-lg q-py-sm info-block">
    <div class="info-block-text">
      <!-- <b>Contact FleetPartners for more information</b> -->

      <b>Contact {{ companyName }} for more information</b>
    </div>

    <!-- <div class="info-block-text">1300 666 001</div>
    <div v-if="region === 'NZ'">
      <p><a href="mailto:Service@fleetpartners.co.nz" target="_blank">Service@fleetpartners.co.nz</a></p>
      <p><a href="https://www.fleetpartners.co.nz/terms-of-use" target="_blank">www.fleetpartners.co.nz/terms-of-use</a></p>
    </div>
    <div v-else>
      <p><a href="mailto:channel@fleetpartners.com.au" target="_blank">channel@fleetpartners.com.au</a></p>
      <p><a href="https://www.fleetpartners.com.au/terms-of-use" target="_blank">www.fleetpartners.com.au/terms-of-use</a></p>
    </div> -->

    <!-- white label -->
    <div class="info-block-text">{{ contacts.phone }}</div>
    <div>
      <p>
        <a :href="`mailto:${contacts.email}`" target="_blank">{{ contacts.email }}</a>
      </p>
      <p><a :href="contacts.terms" target="_blank">Terms of Use</a></p>
    </div>
  </div>
</template>

<script>
/**
 * This component represents common UI for displaying the status in the progress list
 */
import { mapState, mapGetters } from 'vuex';
export default {
  name: 'InfoBlock',
  computed: {
    ...mapState({
      scoreboard: (state) =>
        state.vehicleApplication?.vehicleApplication?.scoreboard ? state.vehicleApplication?.vehicleApplication?.scoreboard : null
    }),
    ...mapGetters({
      orgProfile: 'theme/getScoreboard',
      whiteLabel: 'theme/getWhitelabel'
    }),
    region() {
      return this.scoreboard?.currentUser?.region ? this.scoreboard?.currentUser?.region : 'AU';
    },
    companyName() {
      return this.whiteLabel?.introducerName ? this.whiteLabel.introducerName : 'FleetPartners';
    },
    contacts() {
      if (this.region == 'AU') {
        return {
          phone: this.orgProfile.phoneNumber || '1300 666 001',
          email: this.orgProfile.email || 'channel@fleetpartners.com.au',
          terms: this.whiteLabel.termsLink || 'https://www.fleetpartners.com.au/terms-of-use'
        };
      } else {
        return {
          phone: this.orgProfile.phoneNumber || '1300 666 001',
          email: this.orgProfile.email || 'Service@fleetpartners.co.nz',
          terms: this.whiteLabel.termsLink || 'https://www.fleetpartners.co.nz/terms-of-use'
        };
      }
    }
  }
};
</script>
